import React from 'react'
import { Field } from 'react-final-form'

import PropTypes from 'prop-types'

const Value = ({ name, children }) => (
  <Field name={name} subscription={{ value: true }}>
    {({ input: { value } }) => children({ value })}
  </Field>
)

export default Value

Value.propTypes = {
  name: PropTypes.string,
  children: PropTypes.func
}
